<template>
  <div>
    <div class="vd-gl-search-form">
      <a-form layout="inline">
        <a-form-item>
          <a-input
            class="vd-input-xs"
            v-model="search.username"
            placeholder="用户名"
            allowClear
          />
        </a-form-item>
        <a-form-item>
          <a-input
            class="vd-input-xs"
            v-model="search.code"
            placeholder="工号"
            allowClear
          />
        </a-form-item>
        <a-form-item>
          <a-select
            style="width: 108px"
            v-model="search.pageId"
            :allowClear="true"
            placeholder="推广页面"
          >
            <a-select-option
              v-for="item in pageList"
              :value="item.id"
              :key="item.id"
            >
              {{ item.remark }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item>
          <a-button @click="onSearch" type="search" class="common-button">
            搜索
          </a-button>
        </a-form-item>
      </a-form>
    </div>
    <div class="vd-gl-content">
      <a-row type="flex" class="vd-table-head">
        <a-col flex="auto" class="vd-table-name"> 成员列表</a-col>
        <a-col class="vd-table-tool">
          <a-button-group class="vd-bar-button">
            <a-button :loading="batchQrCodeStatus" @click="batchQrCode">
              批量生成二维码
            </a-button>
            <a-button :loading="downFileStatus" @click="downFile">
              批量导出二维码
            </a-button>
          </a-button-group>
          <!-- <a-divider type="vertical" /> -->
          <!-- <a-icon class="common-icon" type="reload"></a-icon> -->
        </a-col>
      </a-row>

      <a-table
        row-key="id"
        :data-source="tableData"
        :pagination="pagination"
        :loading="loading"
      >
        <a-table-column title="ID" data-index="id" />
        <a-table-column align="center" title="姓名" data-index="name">
          <span slot-scope="text, record">
            {{ record.uid === 0 ? text : record.nickname }}
          </span>
        </a-table-column>
        <a-table-column align="center" title="工号" data-index="code">
          <span slot-scope="text, record">
            {{ record.uid === 0 ? text : record.username }}
          </span>
        </a-table-column>
        <a-table-column align="center" title="收集量" data-index="complete" />
        <a-table-column align="center" title="推广页面" data-index="path_img">
          <template slot-scope="text, record">
            <a-tooltip>
              <template slot="title">
                <img :src="text" alt="默认首页" style="width: 126px" />
              </template>
              <div>{{ record.remark }}</div>
            </a-tooltip>
          </template>
        </a-table-column>

        <a-table-column title="推广二维码" data-index="qrcode">
          <template slot-scope="text">
            <a-tooltip>
              <template slot="title">
                <img
                  :src="$HelperUtil.isEmpty(text) ? '' : text"
                  alt="二维码"
                  style="width: 160px"
                />
              </template>
              <a-avatar
                :src="$HelperUtil.isEmpty(text) ? '' : text"
                shape="square"
                :size="84"
                >二维码
              </a-avatar>
            </a-tooltip>
          </template>
        </a-table-column>

        <a-table-column align="center" title="操作">
          <template slot-scope="record">
            <a-tooltip
              placement="top"
              title="获取二维码"
              v-if="$HelperUtil.isEmpty(record.qrcode)"
            >
              <a-icon
                type="qrcode"
                class="common-icon"
                @click="createQr(record)"
              />
            </a-tooltip>
            <template v-if="!$HelperUtil.isEmpty(record.qrcode)">
              <a-tooltip placement="top" title="下载二维码">
                <a-icon
                  type="download"
                  class="common-icon"
                  @click="
                    downloadQr(
                      record.qrcode,
                      record.active_id + '-' + record.name
                    )
                  "
                />
              </a-tooltip>
            </template>
            <a-tooltip
              placement="top"
              title="移除推广员"
              v-if="$AuthUtil.authRoute('/program/detail/member/remove')"
            >
              <a-popconfirm
                title="移除该推广员? 该推广员收集的信息也会被移除!"
                ok-text="移除"
                cancel-text="取消"
                @confirm="removeQr(record)"
              >
                <a-icon
                  slot="icon"
                  type="exclamation-circle"
                  style="color: red"
                />
                <a-icon type="delete" class="common-icon" />
              </a-popconfirm>
            </a-tooltip>
          </template>
        </a-table-column>
      </a-table>
    </div>

    <Top></Top>
  </div>
</template>

<script>
import {
  getActiveMember,
  create_qr,
  removeQrCode,
  exportQr,
  getPromotionPage,
} from '@/api/program'
import Top from '@/components/top'

export default {
  components: { Top },
  name: 'Member',
  data() {
    return {
      search: {
        username: undefined,
        code: undefined,
        pageId: undefined,
      },
      editModal: false,
      //修改窗口
      edit_id: 0,
      edit_task: 0,
      pForm: {
        num: 1,
        task: 9,
        promotion_id: undefined,
      },
      // table
      id: null /* 当前活动 id*/,
      tableData: [],
      pageList: [],
      pagination: {
        total: 0,
        current: 1,
        pageSize: 5,
        onChange: (page) => {
          this.pagination.current = page
          this.getData()
        },
      },
      loading: false,
      downFileStatus: false,
      batchQrCodeStatus: false,
    }
  },
  mounted() {
    this.id = parseInt(this.$route.query.id)
    this.getData()
    getPromotionPage({ active_id: this.id }).then((res) => {
      if (res.code === 1) {
        this.pageList = res.list
        this.$message.success({ content: res.msg, key: 'p_page' })
      } else {
        this.$message.warning({ content: res.msg, key: 'p_page' })
      }
    })
  },
  methods: {
    /* 批量生成 二维码 */
    batchQrCode() {
      this.batchQrCodeStatus = true
      // 为没有二维码的生成二维码
      create_qr({
        activeId: this.id,
      }).then((res) => {
        this.batchQrCodeStatus = false
        if (res['code'] === 1) {
          this.$message.success(res['msg'])
          this.getData()
        } else {
          this.$message.warning(res['msg'])
        }
      })
    },
    downFile() {
      this.downFileStatus = true
      exportQr({
        activeId: this.id,
      }).then((res) => {
        this.downFileStatus = false
        if (res.type === 'application/json') {
          let reader = new FileReader()
          reader.readAsText(res, 'utf-8')
          reader.addEventListener('loadend', () => {
            let msg = JSON.parse(reader.result)
            this.$message.error(msg['msg'])
          })
        } else {
          const disposition = res.headers['content-disposition']
          let fileName = disposition.substring(
            disposition.indexOf('filename=') + 9,
            disposition.length
          )

          let link = document.createElement('a')
          link.style.display = 'none'
          let url = window.URL.createObjectURL(
            new Blob([res.data], {
              type: 'application/vnd.ms-excel',
            })
          )
          link.href = url
          link.setAttribute('download', fileName)
          document.body.appendChild(link)
          link.click()
          window.URL.revokeObjectURL(url)
        }
      })
    },
    // ------- table --------
    /* 生成推广二维码 */
    createQr({ id, nickname }) {
      create_qr({
        memberId: id,
        activeId: this.id,
      }).then((res) => {
        if (res.code === 1) {
          this.$message.success(`${nickname} 推广二维码创建成功`)
          this.getData()
        } else {
          this.$message.warning(res.msg)
        }
      })
    },
    downloadQr(url, filename) {
      let img = new Image()
      img.setAttribute('crossOrigin', 'Anonymous')
      img.onload = function() {
        let canvas = document.createElement('canvas')
        let context = canvas.getContext('2d')
        canvas.width = img.width
        canvas.height = img.height
        context.drawImage(img, 0, 0, img.width, img.height)
        let url = canvas.toDataURL('images/png')
        let a = document.createElement('a')
        let event = new MouseEvent('click')
        a.download = filename + '.png'
        a.href = url
        a.dispatchEvent(event)
      }
      img.src = url
    },
    removeQr(record) {
      removeQrCode({
        id: record.id,
        activeId: this.id,
      }).then((res) => {
        if (res.code === 1) {
          this.$message.success(res.msg)
          this.getData()
        } else {
          this.$message.warning(res.msg)
        }
      })
    },

    onSearch() {
      this.pagination.current = 1
      this.pagination.total = 0
      this.getData()
    },
    getData() {
      getActiveMember({
        active_id: this.id,
        current: this.pagination.current,
        page_size: this.pagination.pageSize,
        username: this.search.username,
        code: this.search.code,
        pageId: this.search.pageId,
      }).then((res) => {
        if (res.code === 1) {
          this.tableData = res.tableData
          this.pagination.total = res.total
        } else {
          this.$message.warning(res.msg)
        }
      })
    },
  },
}
</script>

<style lang="less" scoped></style>
